<template>
  <div class="technology">
    <div class="technology-banner">
      <img src="../assets/img/tech_banner.png" alt="">
      <div>技术支持</div>
    </div>
    <div class="technology-title">技术</div>
    <div class="technology-content">
        <div class="technology-content-left">
          <div v-for="(item,index) in typeList" :key="index" :class="{active:currentData == index}" @click="chooseType(item,index)">{{item.title}}</div>
        </div>
        <div class="technology-content-right">
          <div>{{chooseItem.description}}</div>
          <div><img :src="fileUrl + chooseItem.thumb" alt=""></div>
        </div>
    </div>
    <!-- <div>
      <div class="technology-type">
        <div v-for="(item,index) in typeList" :key="index" :class="{active:currentData == index}" @click="chooseType(item,index)">{{item.title}}</div>
      </div>
      <div class="technology-content">
        <div class="technology-content-title">
          <img :src="titleImg" alt="">
          <div>{{chooseItem.title}}</div>
        </div>
        <div class="technology-content-content">{{chooseItem.description}}</div>
        <img :src="fileUrl + chooseItem.thumb" alt="">
      </div>
    </div> -->
    
  </div>
</template>

<script>
import { mapState} from 'vuex'
import * as API from '../api/api'
export default {
  data(){
    return{
      isActive:false,
      currentData:0,
      // typeList:config.getTech_Imgs(config.ImageType.technology),
      titleImg:require('../assets/img/tech-title1.png'),
      chooseItem:{},
      typeList:[]
    }
  },
  computed: {
    ...mapState({fileUrl:state => state.fileUrl})
  },
  mounted(){
    this.getComponent()
  },
  methods:{
    chooseType(item,index){
      console.log(item);
      this.currentData=index;
      this.chooseItem=item;
    },
    getComponent(){
      let that=this
      let params={
        ComponentType:2,
        page:1,
        take:20
      }
      API.getComponents(params).then(res=>{
        if (res&&res.data) {
          that.typeList=res.data.contents
          that.chooseItem=res.data.contents[0]
        } else {
          that.$message({
            message: '获取数据失败',
            type: 'warning',
            duration:4000
          })
        }
        
      })
    }
  }  
}
</script>

<style lang="scss" scoped>
  .technology{
    padding-bottom: 1rem;
    &-banner{
      width: 100%;
      height: 4.4rem;
      background: #F4F6FC;
      position: relative;
      >img{
        width: 4.16rem;
        height: 2.7rem;
        position: absolute;
        right: 4.7rem;
        top: 1.4rem;
      }
      >div{
        position: absolute;
        left:4.2rem;
        top: 2.2rem;
        color: #000;
        font-size: 0.38rem;
      }
    }
    &-title{
      font-size: 0.38rem;
      color: #000;
      letter-spacing: 8px;
      text-align: center;
      margin-top: 0.95rem;
      margin-bottom: 0.5rem;
    }
    &-content{
      width: 12rem;
      margin: auto;
      display: flex;
      &-left{
        border-right: 2px solid #DCDCDC;
        font-size: 0.28rem;
        >div{
          padding: 0.3rem;
          cursor: pointer;
          position: relative;
        }
        >div:hover{
          color: #0052D9;
        }
        .active{
          color: #0052D9;
        }
        .active::after{
          content: '';
          width: 2px;
          height: 0.4rem !important;
          background-color: #0052D9;
          position: absolute;
          right: -2px;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }
      &-right{
        width: 8.5rem;
        margin-left: 0.3rem;
        >div:nth-child(1){
          color: #333333;
          font-size: 0.18rem;
          line-height: 0.4rem;
          border-bottom: 1px solid #BFBFBF;
          padding-bottom: 0.4rem;
          margin-bottom: 0.4rem;
        }
        >div:nth-child(2){
          width: 100%;
          height: 4.26rem;
          overflow: hidden;
          >img{
            width: 100%;
            height: 100%;
            transition: all 0.6s;
          }
          >img:hover{
            transform: scale(1.8);
          }
        }
        
      }
    }
  }
</style>